import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOnline } from '@/shared/lib/hooks';

/** Mounted once near the app root (docs/PLAN.md §6) — shows while `navigator.onLine` is false. */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnline();

  if (online) return null;

  return (
    <Alert
      banner
      type="warning"
      showIcon
      message={t('offline.banner')}
      style={{ position: 'sticky', top: 0, zIndex: 1000 }}
    />
  );
}
